import styled from "styled-components";

export const CmpMainPageContent = styled.div`
  /* display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px; */
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap: 24px;
`;

export const CmpMainHeader = styled.div`
  width: 70%;
  span {
    color: ${(props) => [props.theme.colors.primary]};
    font-weight: 700;
  }
  font-size: 2.4rem;
  font-weight: 600;
  word-break: break-all;
  word-wrap: break-word;
  white-space: normal;

  @media (max-width: 410px) {
    font-size: 2rem;
  }
`;

export const CmpMaininfoBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  background-color: rgba(240, 240, 240, 1);
  padding: 33px;
  border-radius: 18px;
  gap: 24px;

  .f1 {
    font-size: 2rem;
    font-weight: 600;
  }

  @media (max-width: 410px) {
    .f1 {
      font-size: 1.7rem;
    }
  }
`;

export const CmpMaindataBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  /* 
  .detailContext {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: -60px;
  }

  .info {
    display: flex;
    align-items: center;
    text-align: center;
    gap: 6px;
  } */
  /* 
  .num {
    background-color: rgba(29, 78, 215, 1);
    width: 25px;
    height: 25px;
    text-align: center;
    color: white;
    font-size: 1.2rem;
    font-weight: 500;
  }

  .rinfo {
    display: flex;
    flex-direction: row;
  }

  p {
    font-size: 1.4rem;
  }

  span {
    font-size: 12px;
    padding-left: 30px;
  } */
`;

export const NumberBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 6px;
`;

export const NumberContent = styled.div`
  width: 25px;
  height: 25px;
  background-color: rgba(29, 78, 215, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 1.4rem;
  font-weight: 500;

  @media (max-width: 410px) {
    width: 21px;
    height: 21px;
    font-size: 1.2rem;
  }
`;

export const NumberBoxText = styled.p`
  padding-left: 3px;
  font-size: 1.6rem;
  font-weight: 500;
  color: ${(props) => props.theme.colors.black};

  @media (max-width: 410px) {
    font-size: 1.4rem;
  }
`;

export const NumberDetailBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const NumberDetailText = styled.p`
  font-size: 1.4rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.gray};
  padding-left: 35px;

  @media (max-width: 410px) {
    font-size: 1.2rem;
  }
`;

export const ButtonBox = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: end;
  padding-bottom: 20px;
  .small {
    width: 60%;
  }
`;
